<div
  *ngIf="
    (!options.formState.isMulti && isAddressSet && !props.cardViewDisabled) ||
      props.print;
    else lookupTmpl
  "
>
  <div class="position-relative break-inside-avoid">
    <div class="address-type__card mb-2">
      <div class="d-flex justify-content-end mb-1" *ngIf="!props.readonly">
        <div class="hstack gap-_5">
          <button luiCab type="button">
            <mat-icon (click)="edit()" svgIcon="edit"></mat-icon>
          </button>
          <button luiCab type="button">
            <mat-icon (click)="delete()" svgIcon="trash"></mat-icon>
          </button>
        </div>
      </div>
      <table class="w-100">
        <tr>
          <td>{{ props.label }}:</td>
          <td class="bold">
            {{ internalForm.value | address }}
          </td>
        </tr>
      </table>
    </div>
  </div>
</div>

<ng-template #lookupTmpl>
  <div
    class="position-relative"
    [style.display]="showManualAddress ? 'none' : 'block'"
  >
    <lui-avatar
      *ngIf="props.tooltip"
      color="primary"
      class="address-type__tooltip ms-auto d-flex"
      [size]="20"
      [matTooltip]="props.tooltip.text"
      [useClickListener]="true"
    >
      <mat-icon svgIcon="i"></mat-icon>
    </lui-avatar>
    <lui-address-lookup
      [label]="$any(props.label)"
      [required]="props.required"
      [origin]="props.origin"
      (addressSelected)="onAddressSelected($event)"
    ></lui-address-lookup>

    <div class="d-flex justify-content-end">
      <button
        luiLink
        class="mat-small"
        type="button"
        (click)="toggleManualAddress()"
        i18n
        [id]="field.id + '-manual-address'"
      >
        Enter address manually
      </button>
    </div>
  </div>
</ng-template>

<div [style.display]="showManualAddress ? 'block' : 'none'">
  <formly-form
    [form]="internalForm"
    [fields]="fields"
    (modelChange)="onModelChange(internalForm.value)"
  ></formly-form>

  <div class="d-flex justify-content-end">
    <button
      luiLink
      class="mat-small mb-1"
      type="button"
      (click)="toggleManualAddress()"
      i18n
      >Lookup address</button
    >
  </div>
</div>
